/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import edit from './edit';
import icon from './icon';
var metadata = {
  name: "core/code",
  category: "formatting",
  attributes: {
    content: {
      type: "string",
      source: "text",
      selector: "code"
    }
  }
};
import save from './save';
import transforms from './transforms';
var name = metadata.name;
export { metadata, name };
export var settings = {
  title: __('Code'),
  description: __('Display code snippets that respect your spacing and tabs.'),
  icon: icon,
  example: {
    attributes: {
      content: __('// A "block" is the abstract term used') + '\n' + __('// to describe units of markup that,') + '\n' + __('// when composed together, form the') + '\n' + __('// content or layout of a page.') + '\n' + __('registerBlockType( name, settings );')
    }
  },
  supports: {
    html: false
  },
  transforms: transforms,
  edit: edit,
  save: save
};
//# sourceMappingURL=index.js.map